import { User, Briefcase, FileText } from "lucide-react";
import StepCard from "./StepCard";

const HowItWorksSection = ({ currentLang, onStepClick }) => {
  const steps = [
    {
      stepNumber: 1,
      icon: User,
      title: currentLang === "ar" ? "البيانات الشخصية" :
             currentLang === "fr" ? "Données Personnelles" : "Personal Data",
      description: currentLang === "ar" ? 
        "املأ بياناتك الشخصية الأساسية بما في ذلك الاسم الكامل، نوع الهوية، الجنسية، والبريد الإلكتروني" :
        currentLang === "fr" ? 
        "Remplissez vos informations personnelles de base incluant le nom complet, le type de pièce d'identité, la nationalité et l'email" :
        "Fill in your basic personal information including full name, ID type, nationality, and email",
      borderColor: "border-blue-500",
      iconBgColor: "bg-blue-100",
      iconColor: "text-blue-600",
    },
    {
      stepNumber: 2,
      icon: Briefcase,
      title: currentLang === "ar" ? "بيانات الاستثمار" :
             currentLang === "fr" ? "Données d'Investissement" : "Investment Data",
      description: currentLang === "ar" ? 
        "اختر القطاع والشركة التي ترغب في الاستثمار فيها، وحدد مبلغ الاستثمار المطلوب" :
        currentLang === "fr" ? 
        "Choisissez le secteur et l'entreprise dans laquelle vous souhaitez investir, et spécifiez le montant d'investissement requis" :
        "Choose the sector and company you want to invest in, and specify the required investment amount",
      borderColor: "border-green-500",
      iconBgColor: "bg-green-100",
      iconColor: "text-green-600",
    },
    {
      stepNumber: 3,
      icon: FileText,
      title: currentLang === "ar" ? "المستندات المطلوبة" :
             currentLang === "fr" ? "Documents Requis" : "Required Documents",
      description: currentLang === "ar" ? 
        "ارفق المستندات المطلوبة بما في ذلك صورة تحقيق الشخصية، السجل التجاري، والبطاقة الضريبية" :
        currentLang === "fr" ? 
        "Téléchargez les documents requis incluant la photo d'identité, le registre commercial et la carte fiscale" :
        "Upload required documents including identity photo, commercial register, and tax card",
      borderColor: "border-purple-500",
      iconBgColor: "bg-purple-100",
      iconColor: "text-purple-600",
    },
  ];

  return (
    <div className="mb-16">
      <div className="text-center mb-12">
        <h2 className="text-4xl font-bold text-gray-900 dark:text-white mb-4">
          {currentLang === "ar" ? "كيفية التقديم للاستثمار" :
           currentLang === "fr" ? "Comment Postuler pour l'Investissement" : "How to Apply for Investment"}
        </h2>
        <p className="text-xl text-gray-600 dark:text-gray-300 max-w-2xl mx-auto">
          {currentLang === "ar" ? "3 خطوات بسيطة لتقديم طلب الاستثمار" :
           currentLang === "fr" ? "3 étapes simples pour soumettre votre demande d'investissement" :
           "3 simple steps to submit your investment request"}
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
        {steps.map((step) => (
          <StepCard
            key={step.stepNumber}
            {...step}
            learnMoreText={currentLang === "ar" ? "اعرف المزيد" :
                           currentLang === "fr" ? "En savoir plus" : "Learn More"}
            onClick={() => onStepClick(step.stepNumber)}
          />
        ))}
      </div>
    </div>
  );
};

export default HowItWorksSection;